import React from 'react';
import {
  Paper, Typography, List, ListItem, ListItemText, Chip, Stack,
} from '@mui/material';
import dayjs from 'dayjs';

export default function CrmTasksDue({ tasks }) {
  const today = dayjs().format('YYYY-MM-DD');
  const dueToday = tasks.filter((t) => t.due === today && t.status !== 'Completed');
  const overdue = tasks.filter((t) => dayjs(t.due).isBefore(today) && t.status !== 'Completed');

  return (
    <Paper sx={{ p: 3, mb: 2 }}>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        Tasks Due / Overdue
      </Typography>
      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <Chip label={`Due Today: ${dueToday.length}`} color="info" />
        <Chip label={`Overdue: ${overdue.length}`} color="error" />
      </Stack>
      <List>
        {[...dueToday, ...overdue].slice(0, 5).map((task, idx) => (
          <ListItem key={idx}>
            <ListItemText
              primary={task.title}
              secondary={`Due: ${task.due} | Status: ${task.status}`}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
